import React from 'react';

const AdobePhotoshopIcon = ({classes}) => (
  <svg className={classes} role="img" viewBox="0 0 455 455">
    <g>
      <path
        d="M149.329,144.802c-11.069,0-18.7,1.105-22.547,2.209v71.674
		c4.698,1.01,10.374,1.357,18.257,1.357c29.168,0,47.3-14.758,47.3-39.669C192.214,158.079,176.794,144.802,149.329,144.802z"
      />
      <path
        d="M0,0v455h455V0H0z M224.219,236.693
		c-18.604,17.595-46.417,25.479-78.834,25.479c-7.125,0-13.654-0.252-18.698-0.978v86.844H72.354V108.445
		c16.872-2.837,40.647-5.046,74.136-5.046c33.899,0,58.021,6.401,74.167,19.456c15.64,12.204,25.983,32.417,25.983,56.194
		C246.64,202.794,238.758,223.007,224.219,236.693z M306.27,351.601c-23.05,0-43.609-5.047-56.916-12.299l9.743-39.196
		c10.091,6.055,30.904,13.307,47.173,13.307c16.492,0,23.398-5.77,23.398-14.789c0-8.988-5.424-13.276-25.856-20.182
		c-36.484-12.202-50.518-32.038-50.139-52.976c0-32.763,28.096-57.644,71.676-57.644c20.592,0,38.944,4.667,49.76,10.091
		l-9.714,37.839c-8.009-4.319-23.05-10.122-38.185-10.122c-13.307,0-20.813,5.424-20.813,14.412c0,8.261,6.781,12.581,28.318,20.213
		c33.52,11.446,47.552,28.443,47.932,54.333C382.646,327.477,356.63,351.601,306.27,351.601z"
      />
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
);

export default AdobePhotoshopIcon;
